<template>
  <base-modal
    hide-footer
    hide-header
    :closeable-from-outside="false"
    :size="'sm'"
    :modal-id="'preview-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <div class="close-modal" @click="$emit('onCloseModal')">
      <feather-icon icon="XIcon" size="25" />
    </div>
    <div class="template-wrapper-container">
      <template-wrapper
        :templateData="formModal"
        :templateId="formModal.templateSelect"
      ></template-wrapper>
    </div>
  </base-modal>
</template>

<script>
import TemplateWrapper from "./template/TemplateWrapper.vue";
import useCodeTemplate from "../../code-template-info/hooks/useCodeTemplate";
import {
  onBeforeMount,
  onMounted,
  reactive,
  ref,
  watch,
} from "@vue/composition-api";
export default {
  components: { TemplateWrapper },
  props: {
    templateId: { type: [Number, String], default: 1 },
    templateData: { type: [Object, Array], default: null },
  },
  setup(props) {
    const { formModal, fetchDataCodeTemplate } = useCodeTemplate();

    onBeforeMount(() => {
      fetchDataCodeTemplate(props.templateId);
    });

    return {
      formModal,
      fetchDataCodeTemplate,
    };
  },
};
</script>

<style>
#preview-modal .modal-content {
  background-color: unset !important;
  box-shadow: none !important;
}
</style>

<style scoped>
#preview-modal .template-wrapper-container {
  margin: 70px !important;
}

#preview-modal .close-modal {
  position: absolute;
  right: 13px;
  top: 54px;
  color: #000000;
  cursor: pointer;
}
</style>
